import React from "react";
import { toast } from "../../../components/Toast/toast.ts";
import { Search } from "lucide-react";

export default function SearchBar({ fetchFilteredData, searchVal, setSearchVal }) {

  const handleInput = (e) => {
    setSearchVal((e?.target.value).toLowerCase());
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      if (searchVal === "") {
        toast.error("Please enter some text to search.");
      } else {
        fetchFilteredData();
      }
    }
  };

  const handleSearchIconClick = () => {
    if (searchVal === "") {
      toast.error("Please enter some text to search.");
    } else {
      fetchFilteredData();
    }
  }

  return (
    <div className="flex items-center gap-2 px-3 py-1.5 rounded-md border border-[rgb(var(--border-secondary))] bg-[rgb(var(--surface-2))] focus-within:border-gold-2 focus-within:ring-1 focus-within:ring-gold-2/30 transition-all min-w-[180px]">
      <Search
        size={14}
        className="text-[rgb(var(--text-muted))] shrink-0 cursor-pointer hover:text-[rgb(var(--text-primary))] transition-colors"
        onClick={handleSearchIconClick}
      />
      <input
        className="bg-transparent border-none outline-none text-[12px] text-[rgb(var(--text-primary))] placeholder:text-[rgb(var(--text-muted))] w-full"
        onChange={handleInput}
        onKeyDown={handleKeyPress}
        value={searchVal}
        type="text"
        name="search"
        placeholder="Search..."
      />
    </div>
  );
}
